import React from 'react';
import {formatWithMask} from 'react-native-mask-input';

export const useMaskZip = ({
  isUSA,
  isCanada,
}: {
  isUSA: boolean;
  isCanada: boolean;
}) => {
  return (text: string | undefined) => {
    if (!text) {
      return '';
    }

    if (!isUSA && !isCanada) {
      return text;
    }
    const {masked} = formatWithMask({
      text,
      mask: isUSA
        ? [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
        : [/[a-zA-Z]/, /\d/, /[a-zA-Z]/, ' ', /\d/, /[a-zA-Z]/, /\d/],
    });

    return masked.toUpperCase();
  };
};
